import { render, staticRenderFns } from "./internalBillInfo.vue?vue&type=template&id=f2c3cc30&scoped=true&"
import script from "./internalBillInfo.vue?vue&type=script&lang=js&"
export * from "./internalBillInfo.vue?vue&type=script&lang=js&"
import style0 from "./internalBillInfo.vue?vue&type=style&index=0&id=f2c3cc30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c3cc30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c3cc30')) {
      api.createRecord('f2c3cc30', component.options)
    } else {
      api.reload('f2c3cc30', component.options)
    }
    module.hot.accept("./internalBillInfo.vue?vue&type=template&id=f2c3cc30&scoped=true&", function () {
      api.rerender('f2c3cc30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/internalBillInfo.vue"
export default component.exports